export default function Footer() {
  return (
    <footer className="bg-black border-t-2 border-red-600">
      <div className="container mx-auto px-6 py-16">
        <div className="flex justify-center mb-12">
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 text-white hover:border-red-600 hover:bg-red-600 transition-all cursor-pointer">
              <i className="ri-facebook-fill"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 text-white hover:border-red-600 hover:bg-red-600 transition-all cursor-pointer">
              <i className="ri-instagram-line"></i>
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-red-600/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © 2025 JMS Train Rides. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-white/60 hover:text-red-500 transition-colors cursor-pointer">
                Terms
              </a>
              <span className="text-white/30">|</span>
              <a href="#" className="text-white/60 hover:text-red-500 transition-colors cursor-pointer">
                Privacy
              </a>
              <span className="text-white/30">|</span>
              <a href="#" className="text-white/60 hover:text-red-500 transition-colors cursor-pointer">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
